import axios from "axios";
import Cookies from "js-cookie";
import translations from "../components/common/Translations";
import { withApiError, withApiErrorResponse, apiErrorMessage } from "../utils/apiError";

const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;

export const createAssignmentRule = async (
  // workflowId,
  projectId,
  criteria,
  ruleName,
  isActive,
  selectedUserId,
  selectedGroupId = null
) => {
  const url = `${BASE_URL}api/v1/assignment-rule/create`;
  const data = {
    projectId: Number(projectId),
    rule: criteria,
    ruleName,
    activeStatus: isActive,
    userId: selectedGroupId ? null : selectedUserId,
    groupId: selectedGroupId || null,
  };
  const token = Cookies.get("accessToken");

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    return withApiError(responseData);
  } catch (error) {
    throw new Error(`Error submitting form: ${error.message}`);
  }
};

export const fetchAreaCodes = async (token, workflowId) => {
  try {
    const response = await axios.get(`${BASE_URL}api/v1/task/get-area-list`, {
      params: {
        workflowId: workflowId,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return response.data.body.value;
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};
export const assignmentRules = async (
  reset = false,
  // workflowId,
  projectId,
  currentPage,
  pageSize,
  setAssignmentList,
  setError,
  setTotalCount
) => {
  if (!projectId) {
    console.warn("projectId is required to fetch task priority count");
    return;
  }

  const token = Cookies.get("accessToken");

  try {
    const response = await fetch(
      `${BASE_URL}api/v1/assignment-rule/getAll?projectId=${projectId}&page=${currentPage}&size=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const jsonData = await response.json();
    const newData = jsonData.body.value.list || [];

    setAssignmentList(newData);

    setTotalCount(jsonData.body.value.totalCount)
    // setHasMore(moreData); // If less than 'size' items are returned, we know there's no more data
  } catch (error) {
    setError(error);
  }
};

export const updateFunction = async (
  assignment,
  // workflowId,
  projectId,
  fetchAssignmentRules,
  toast,
  setDropdownOpen,
  updatedUserIdList,
  langMode,
  onSuccess
) => {
  const { id, ruleName, userId, groupId, assignScope, rule, activeStatus } = assignment;
  console.log(userId, "userId", groupId, "groupId");

  const url = `${BASE_URL}api/v1/assignment-rule/update`;
  const hasGroup = assignScope === "groups" || (groupId != null && groupId !== "");
  const data = {
    id: Number(id),
    // workflowId: Number(workflowId), // Assuming workflowId is passed as a parameter
    projectId,
    rule: rule,
    ruleName: ruleName,
    userId: hasGroup ? null : (updatedUserIdList ?? userId),
    groupId: hasGroup ? Number(groupId) : null,
    activeStatus: activeStatus,
  };
  const token = Cookies.get("accessToken");
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    if (responseData.header.code === 600) {
      const message = responseData.body?.value;
      toast.success(message || translations[langMode].ruleupdatedsuc);
      setDropdownOpen(false);
      fetchAssignmentRules();
      onSuccess?.();
    } else {
      toast.error(apiErrorMessage(responseData, "Error updating assignment rule"));
    }
  } catch (error) {
    console.error("Error updating assignment rule:", error);
  }
};

export const assignmentRulesList = async (
  reset = false,
  workflowId,
  page,
  size,
  setIsLoading,
  setAssignmentList,
  setHasMore,
  setError
) => {
  const token = Cookies.get("accessToken");
  setIsLoading(true);
  try {
    const response = await fetch(
      `${BASE_URL}api/v1/assignment-rule/get-list?workflowId=${workflowId}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const jsonData = await response.json();
    if (
      jsonData.body.value === "No Data Found" ||
      jsonData.body.value.length === 0
    ) {
      setHasMore(false);
    } else {
      if (reset) {
        setAssignmentList(jsonData.body.value.list);
      } else {
        setAssignmentList((prevList) => [
          ...new Set([...prevList, ...jsonData.body.value]),
        ]);
      }
      setHasMore(jsonData.body.value.length === size);
    }
  } catch (error) {
    setError(error);
  } finally {
    setIsLoading(false);
  }
};

export const smartAssignRulesList = async (
  reset = false,
  projectId,
  page,
  size,
  setIsLoading,
  setAssignmentList,
  setHasMore,
  setError
) => {
  if (!projectId) {
    console.warn("projectId is required to fetch Data");
    return;
  }
  const token = Cookies.get("accessToken");
  setIsLoading(true);
  try {
    const response = await fetch(
      `${BASE_URL}api/v1/assignment-rule/get-rule-names?projectId=${projectId}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const jsonData = await response.json();
    const rules = jsonData?.body?.value?.ruleNameList || [];

    if (jsonData?.body?.value === "No Data Found" || rules.length === 0) {
      setHasMore(false);
    } else {
      setAssignmentList((prevList) =>
        reset ? rules : [...prevList, ...rules]
      );
      setHasMore(rules.length === size);
    }
  } catch (error) {
    setError(error.message || "An error occurred");
  } finally {
    setIsLoading(false);
  }
};

export const assignByArea = async (selectedIds, isreassignChecked, workflowId) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await fetch(
      `${BASE_URL}api/v1/assignment-rule/assign-by-rules`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ruleIdList: selectedIds,
          isReAssign: isreassignChecked,
          workflowId
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const jsonData = await response.json();
    return withApiError(jsonData);
  } catch (error) {
    console.error("Error assigning by area:", error);
    throw withApiErrorResponse(error);
  }
};

export const fetchCompletionRules = async (selectedWorkflowId, page, size, setCompletionRules, setTotalCount) => {
  const token = Cookies.get("accessToken");
  if (!selectedWorkflowId) {
    console.warn("workflowId is required to fetch Data");
    return {};
  }

  try {
    const response = await fetch(
      `${BASE_URL}api/v1/completion-rule/get-rules?workflowId=${selectedWorkflowId}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch completion rules");
    }

    const data = await response.json();
    setCompletionRules(data.body.value.list) // Assuming 'value' contains the array of rules
    setTotalCount(data.body.value.totalCount)
  } catch (error) {
    console.error("Error fetching completion rules:", error);
    throw withApiErrorResponse(error);
  }
};

export const createCompletionRule = async (
  selectedWorkflowId,
  criteria,
  iconStatus,
  isActive,
  moveTask,
  targetWorkflowId
) => {
  const token = Cookies.get("accessToken");

  try {
    const response = await fetch(
      `${BASE_URL}api/v1/completion-rule/create-rule`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          workflowId: selectedWorkflowId,
          rule: criteria,
          status: iconStatus,
          icon: iconStatus,
          activeStatus: isActive,
          moveTask,
          targetWorkflowId
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      const backendMessage =
        apiErrorMessage(errorData) ||
        errorData?.header?.message ||
        errorData?.message;
      throw new Error(backendMessage || "Failed to create completion rule");
    }

    const jsonData = await response.json();
    return withApiError(jsonData);
  } catch (error) {
    console.error("Error creating completion rule:", error);
    throw withApiErrorResponse(error);
  }
};

export const deleteCompletionRule = async (ruleid) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.delete(
      `${BASE_URL}api/v1/completion-rule/delete-rule?completionRuleId=${ruleid}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};

export const deleteAssignmentRule = async (ruleid) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.delete(
      `${BASE_URL}api/v1/assignment-rule/delete?id=${ruleid}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};

//update compliton rule

export const updateRule = async (
  ruleid,
  icon,
  criteria,
  selectedWorkflowId,
  activeStatus,
  moveTask,
  finalTargetWorkflowId
) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${BASE_URL}api/v1/completion-rule/edit-rule`,
      {
        id: ruleid,
        status: icon,
        icon,
        rule: criteria,
        workflowId: selectedWorkflowId,
        activeStatus,
        moveTask,
        targetWorkflowId: finalTargetWorkflowId
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data); // Assuming API returns data upon success
  } catch (error) {
    console.error("Error updating rule:", error);
    throw withApiErrorResponse(error); // Handle error as needed
  }
};

// get all special assign
// workflowId is optional: without it the backend returns every rule in the
// project; with it, that workflow's rules plus legacy rules with no workflow.
export const getAllSpecialAssign = async (projectId, page, size, workflowId) => {
  try {
    const token = Cookies.get("accessToken");
    const response = await axios.get(`${BASE_URL}api/v1/special-assign/get-all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { projectId, page, size, ...(workflowId ? { workflowId } : {}) },
    });

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return response.data.body.value;
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};

// get all mount range
export const getAllOutstandingRange = async () => {
  try {
    const token = Cookies.get("accessToken");
    const response = await axios.get(`${BASE_URL}api/v1/task/get-outstanding-range`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return response.data.body.value;
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};

//asgin all

// workflowId is optional: with it only that workflow's rules run (on that
// workflow's tasks); without it every active rule runs within its own workflow.
export const assignAll = async (projectId, workflowId) => {
  try {
    const token = Cookies.get("accessToken");
    const response = await axios.get(`${BASE_URL}api/v1/special-assign/assign-all`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { projectId, ...(workflowId ? { workflowId } : {}) },
      });
    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return withApiError(response.data);
  }
  catch (error) {
    throw withApiErrorResponse(error);
  }
};

// get all type code
export const getAllTypeCode = async (projectId) => {
  try {
    const token = Cookies.get("accessToken");

    if (!projectId) {
      return [];
    }
    const response = await axios.get(`${BASE_URL}api/v1/task/get-type-codes?projectId=${projectId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return response.data.body.value;
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};
// get all geo codes
export const getAllGeoCode = async (projectId) => {
  try {
    const token = Cookies.get("accessToken");
    if (!projectId) {
      return [];
    }
    const response = await axios.get(`${BASE_URL}api/v1/task/get-geo-codes?projectId=${projectId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return response?.data?.body?.value;
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};
// get agent name list
export const getAllAgentList = async (activityId) => {
  try {
    const token = Cookies.get("accessToken");
    const response = await axios.get(`${BASE_URL}api/v1/user/field-agents?organizationId=${activityId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    return response.data.body.value;
  } catch (error) {
    throw withApiErrorResponse(error);
  }
};

// get all user list

export const fetchFieldAgent = async (workflowId) => {
  const token = Cookies.get("accessToken");
  // const userType = Cookies.get("userType");

  if (!workflowId) {
    return [];
  }

  const url =
    `${BASE_URL}api/v1/user/field-agents-by-workflow?workflowId=${workflowId}`


  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data.body.value;
};

// create special assign
export const getSpecialAssign = async ({ payload }) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${BASE_URL}api/v1/special-assign/create`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data); // return full data (header + body)
  } catch (error) {
    console.error("Error updating rule:", error);
    throw withApiErrorResponse(error);
  }
};

// urgent task assign -- adds the selected field agents to every open task in
// the chosen workflows x area codes. Always HTTP 200: header.code 600 means the
// job was queued (body.value is a message string, no counts; the requester gets
// an "Urgent Assignment" notification when it finishes), 601 means rejected
// (the message names the invalid workflow or agents).
export const urgentAssign = async ({ projectId, workflowIds, areaCodes, fieldAgentIds }) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${BASE_URL}api/v1/special-assign/urgent-assign`,
      { projectId, workflowIds, areaCodes, fieldAgentIds },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data);
  } catch (error) {
    console.error("Error in urgent assign:", error);
    throw withApiErrorResponse(error);
  }
};


// update special assign
export const getUpdateSpecialAssign = async ({ payload }) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(`${BASE_URL}api/v1/special-assign/update`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data); // Assuming API returns data upon success
  } catch (error) {
    console.error("Error updating rule:", error);
    throw withApiErrorResponse(error); // Handle error as needed
  }
};

//update rules

export const UpdateAssignrule = async (payload) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(`${BASE_URL}api/v1/special-assign/update`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data); // Assuming API returns data upon success
  } catch (error) {
    console.error("Error updating rule:", error);
    throw withApiErrorResponse(error); // Handle error as needed
  }
};

// delete rules
export const DeleteSpecialAssignmentRule = async (id) => {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.delete(
      `${BASE_URL}api/v1/special-assign/delete?id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return withApiError(response.data); // Assuming API returns data upon success
  } catch (error) {
    console.error("Error deleting rule:", error);
    throw withApiErrorResponse(error); // Handle error as needed
  }
}

const extractMapData = (response, allOptions = []) => {
  if (response?.header?.code === 600 && typeof response?.body?.value === "object") {
    const valueObj = response.body.value;
    const options = [];

    // Loop over each activityId key
    for (const [activityId, subActivities] of Object.entries(valueObj)) {
      const activity = allOptions.find((opt) => opt.value === parseInt(activityId));
      const activityName = activity ? activity.label : "Unknown Activity";

      subActivities.forEach((subName) => {
        options.push({
          value: subName,
          label: `${subName} (${activityName})`,
          activityId: parseInt(activityId),
        });
      });
    }

    return options;
  }
  return [];
};


export const getCombinedMapData = async (workflowIds, userId, allOptions = []) => {
  const token = Cookies.get("accessToken");

  try {
    const idsParam = Array.isArray(workflowIds) ? workflowIds.join(",") : workflowIds;

    const [taskRes, userRes] = await Promise.all([
      axios.get(`${BASE_URL}api/v1/task/get-sub-activity`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: { workflowIds: idsParam },
      }),
      axios.get(`${BASE_URL}api/v1/user/get-sub-activity`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: { userId },
      }),
    ]);

    const taskData = extractMapData(taskRes.data, allOptions);
    const userData = extractMapData(userRes.data, allOptions);

    const allMaps = [...taskData, ...userData].filter(
      (item, index, self) => index === self.findIndex((t) => t.value === item.value)
    );

    return {
      allMaps,        // All sub-activities like "DLA (Activity name)"
      preselected: userData,  // Preselected for the user
    };
  } catch (error) {
    console.error("❌ Error fetching combined map data:", error);
    return { allMaps: [], preselected: [] };
  }
};



const extractActivityProjectData = (response) => {
  if (response?.header?.code === 600 && Array.isArray(response?.body?.value)) {
    return response.body.value.map((item) => ({
      workflowId: item.workflowId,
      workflowName: item.workflowName,
    }));
  }
  return [];
};

const extractActivityUserData = (response) => {
  if (response?.header?.code === 600 && Array.isArray(response?.body?.value)) {
    return response.body.value; // just IDs, e.g., [212, 216, 343]
  }
  return [];
};

export const getCombinedActivityData = async (projectId, userId) => {
  const token = Cookies.get("accessToken");

  try {
    const [projectRes, userRes] = await Promise.all([
      axios.get(`${BASE_URL}api/v1/workflow/get-activities`, { // update end point by harshit 23-12-2025
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: { projectId },
      }),
      axios.get(`${BASE_URL}api/v1/user/get-workflow-ids`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: { userId },
      }),
    ]);

    const projectData = extractActivityProjectData(projectRes.data);
    const userIds = extractActivityUserData(userRes.data);

    // ✅ Prepare all workflows as dropdown options
    const allOptions = projectData.map((wf) => ({
      value: wf.workflowId,
      label: wf.workflowName,
    }));

    // ✅ Prepare only user's assigned workflows as preselected
    const preselectedact = allOptions.filter((opt) =>
      userIds.includes(opt.value)
    );

    return { allOptions, preselectedact };
  } catch (error) {
    console.error("❌ Error fetching combined activity data:", error);
    return { allOptions: [], preselected: [] };
  }
};



export const updateUserWorkflows = async (userId, workflowList) => {
  const token = Cookies.get("accessToken");
  try {
    const res = await axios.post(
      `${BASE_URL}api/v1/user/update/workflow-list`,
      { userId, workflowList },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("❌ Error updating user workflows:", error);
    throw withApiErrorResponse(error);
  }
};

export const updateUserSubActivities = async (userId, subActivities) => {
  const token = Cookies.get("accessToken");
  try {
    const res = await axios.post(
      `${BASE_URL}api/v1/user/update/sub-activity`,
      { userId,  subActivities },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("❌ Error updating user sub-activities:", error);
    throw withApiErrorResponse(error);
  }
};
